import downloadLargeTokens from "@amzn/meridian-tokens/base/icon/download-large";
import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Icon from "@amzn/meridian/icon";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  findNextUnreviewedCase,
  isAssignedBasedReview,
} from "src/components/shared/groundTruth/reviewTable/helpers";
import {
  sortAndFilterGroundTruthDataListView,
  getBatchRecordList,
} from "src/store/modelLifeCycleGroundTruthSlice";
import { getModelById, Model, setSelectedModelId } from "src/store/modelManagementSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { hasModelPermission, isAdminUser } from "src/utils/permissionUtil";
import DonutChart from "src/components/shared/donutChart/donutChart";
import "./batchReordListView.scss";
import {
  BatchJobStatus,
  getBatchJobById,
  getPreSignUrlAndDownload,
} from "src/store/batchExtractionSlice";
import ListViewTable from "src/components/shared/groundTruth/listView/listViewTable";

const BatchRecordListView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { batchJobId } = useParams();

  const {
    groundTruthDataListView,
    getListViewLoading,
    groundTruthDataTotalCount,
    groundTruthDataTotalReviewedCount,
  } = useAppSelector((state) => state.modelLifeCycleGroundTruthSlice);

  const { selectedBatchJob } = useAppSelector((state) => state.batchExtractionSlice);

  const { token, alias, ldap } = useAppSelector((state) => state.user);
  const { selectedModel, selectedModelId } = useAppSelector((state) => state.modelSlice);

  useEffect(() => {
    if (batchJobId && token && getListViewLoading !== "fulfilled") {
      dispatch(getBatchRecordList(batchJobId));
    }
    if (batchJobId && token) {
      dispatch(getBatchJobById(batchJobId));
    }
  }, [batchJobId, token]);

  useEffect(() => {
    if (selectedModelId) {
      dispatch(setSelectedModelId(selectedModelId));
    }
  }, [selectedModelId]);

  useEffect(() => {
    if (getListViewLoading === "rejected") {
      navigate(`/batchProcess`);
    } else if (getListViewLoading === "fulfilled" && selectedModel.id) {
      dispatch(
        sortAndFilterGroundTruthDataListView({
          model: selectedModel,
          alias: alias,
          isAdmin: isAdminUser(ldap),
        }),
      );
    }
  }, [getListViewLoading, selectedModel]);

  return (
    <Row widths={["75%", "25%"]}>
      <Column spacingInset={"0 500 500 500"}>
        <BreadcrumbGroup>
          <Breadcrumb onClick={() => navigate(`/batchProcess`)}>Batch Process</Breadcrumb>
          <Breadcrumb onClick={() => navigate(`/batchProcess/${batchJobId}`)}>
            {selectedModel.name} - Processed
          </Breadcrumb>
        </BreadcrumbGroup>
        <Row widths={["65%", "35%"]}>
          <Row spacing={"400"}>
            <Column alignmentHorizontal="start" spacing={"300"}>
              <Text type={"d50"}>Batch Record - Processed</Text>
            </Column>
          </Row>
          <Row alignmentHorizontal="end" widths={["50%"]}>
            <Row alignmentHorizontal="end">
              {hasModelPermission(selectedModel, alias, ldap) &&
                selectedBatchJob.status === BatchJobStatus.Completed && (
                  <Button
                    type="tertiary"
                    onClick={() => {
                      selectedBatchJob &&
                        dispatch(
                          getPreSignUrlAndDownload({
                            jobId: selectedBatchJob.id,
                            s3URL: selectedBatchJob.s3OutputFilePath,
                            fileName: selectedBatchJob.s3OutputFilePath.replace("output/", ""),
                          }),
                        );
                    }}
                    data-cy={"download-ground-truths__button"}
                  >
                    <Icon tokens={downloadLargeTokens}></Icon>
                    Export Extracted Records
                  </Button>
                )}
              <Button
                onClick={() => {
                  const next = findNextUnreviewedCase(groundTruthDataListView, alias);
                  if (next) {
                    navigate(`/batchProcess/${batchJobId}/${next.sourceId}`);
                  } else {
                    navigate(`/batchProcess/${batchJobId}/${groundTruthDataListView[0].sourceId}`);
                  }
                }}
                disabled={groundTruthDataListView.length === 0}
              >
                Review
              </Button>
            </Row>
          </Row>
        </Row>
        <ListViewTable getListViewId={selectedBatchJob.id} navigateUrl={"batchProcess"} />
      </Column>
      <Column
        height={"92vh"}
        className="incident-summary"
        alignmentHorizontal="start"
        spacingInset={"500"}
      >
        {!isAssignedBasedReview(selectedModel) && (
          <>
            <Text type="h300">Overall Batch Process Summary</Text>
            <DonutChart
              totalCount={groundTruthDataTotalCount}
              reviewedCount={groundTruthDataTotalReviewedCount}
              isLoading={getListViewLoading === "pending"}
              title="Total Batch Record"
              subtitle=""
            />
          </>
        )}
      </Column>
    </Row>
  );
};

export default BatchRecordListView;
